var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPersonMinus = function SvgPersonMinus(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M4.5 3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M5.75 13v4a.999.999 0 1 1-2 0v-6.972l-.894 1.488a1 1 0 0 1-1.372.34 1 1 0 0 1-.341-1.372l1.822-3.03a3 3 0 0 1 2.572-1.457h.928c1.053 0 2.028.553 2.572 1.456l1.403 2.334a5.5 5.5 0 0 0-1.144 1.922.9.9 0 0 1-.153-.197l-.894-1.484V17a.999.999 0 1 1-2 0v-4zm4.25.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m7 0c0-.275-.226-.5-.5-.5h-4c-.276 0-.5.225-.5.5s.224.5.5.5h4c.274 0 .5-.225.5-.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPersonMinus);
export default ForwardRef;